import axios from 'axios'

const system = { 
  getMessage : () => axios.get(
    `${process.env.REACT_APP_API_URL}bmc/SystemMessage`
  ).then( res => res.data ),
  getChangelog : (showAll=false) => { 
    if (!showAll) { 
      return axios.get(`${process.env.REACT_APP_API_URL}bmc/Changelog`).then( res => res.data )
    } else {
      return axios.get(`${process.env.REACT_APP_API_URL}bmc/Changelog?showAll=true`).then(res => res.data)
    }
  },
  getLocation: () => axios.get(
    `${process.env.REACT_APP_API_URL}bmc/Location`
  ).then( res => res.data ),
  getLastHelpRequest: () => axios.get(
    `${process.env.REACT_APP_API_URL}bmc/LastHelpRequest`
  ).then( res => res.data),
  sendHelpRequest: (data) => axios.post(
    `${process.env.REACT_APP_API_URL}bmc/SendHelpRequest`, data
  ).then( res => res.data),
  removeHelpRequest: () => axios.post(
    `${process.env.REACT_APP_API_URL}bmc/RemoveHelpRequest`
  ).then( res => res.data),
  linkAdvisor: (code) => axios.post(
    `${process.env.REACT_APP_API_URL}bmc/LinkAdvisor?code=${code}`
  ).then( res => res.data),
  unlinkAdvisor: () => axios.post(
    `${process.env.REACT_APP_API_URL}bmc/UnlinkAdvisor`
  ).then( res => res.data),
}
export default system